// extracted by mini-css-extract-plugin
module.exports = {"Component":"Terms_Component__7VJkq","Text_center":"Terms_Text_center__1YGJJ","Content":"Terms_Content__2kypl"};